export default function (http) {
    return {


        queryByPage(data) {
            return http.json({
                url: `/sku/class/query?pageNum=${data.pageNum}&pageSize=${data.pageSize}`,
                data
            });
        },
        queryLessonByClassAndStu(data) {
            return http.json({
                url: `rep/lesson/appraise/selectLesson?pageNum=${data.pageNum}&pageSize=${data.pageSize}`,
                data
            });
        },
        queryClassStus(data) {
            return http.json({
                url: `/sku/student/queryClassStus?pageNum=${data.pageNum}&pageSize=${data.pageSize}`,
                data
            });
        },

        queryStuBycClassId(data) {
            return http.json({
                url: `/sku/class/queryStuBycClassId?pageNum=${data.pageNum}&pageSize=${data.pageSize}`,
                data
            });
        },

        getInfo(data) {
            return http.json({
                url: `/sku/class/get?id=${data.id}`,
                data
            })
        },

        saveInfo(data) {
            return http.json({
                url: `/sku/class/save`,
                data
            })
        },
        updateState(data) {
            return http.json({
                url: `/sku/class/updateState`,
                data
            })
        },

        endClass(data) {
            return http.json({
                url: `/sku/class/endClass`,
                data
            })
        },

        cancleEndClass(data) {
            return http.json({
                url: `/sku/class/cancleEndClass`,
                data
            })
        },
        getOne(data) {
            return http.json({
                url: `/sku/class/getOne`,
                data
            })
        },


        delete(data) {
            return http.json({
                url: `/sku/class/delete`,
                data
            })
        },

        queryClassTree(data) {
            return http.json({
                url: `/sku/class/queryClassTree`,
                data
            })
        },
    }
}





// WEBPACK FOOTER //
// ./src/configure/http/api/enroll/clazz.js